import { differenceInCalendarDays } from 'date-fns';

import { hasPermission } from '@constants';
import { IProject } from '@types';
import { includesQuery } from 'utils/string';

import { TeamsTableHeader } from '../constants/headers';

export const getVisibleHeaders = (
  permissions: readonly string[],
  hasDeliveryManager: boolean,
): TeamsTableHeader[] => {
  const h: TeamsTableHeader[] = [
    TeamsTableHeader.ProjectTeamMember,
    ...(hasDeliveryManager ? [TeamsTableHeader.DeliveryManager] : []),
    TeamsTableHeader.SowStartDate,
    TeamsTableHeader.SowEndDate,
  ];
  if (hasPermission(permissions, 'P:R'))
    h.push(TeamsTableHeader.NextEvaluation);
  if (hasPermission(permissions, 'F:R'))
    h.push(TeamsTableHeader.Rate, TeamsTableHeader.Allocation);
  return h;
};

export const isSowEndingSoon = (endedAt: string) =>
  Boolean(endedAt) &&
  differenceInCalendarDays(new Date(endedAt), new Date()) <= 60;

export const filterProjects = (projects: IProject[], query: string) =>
  query.trim()
    ? projects
        .map((project) =>
          includesQuery(query, [project.name])
            ? project
            : {
                ...project,
                members: project.members.filter((member) =>
                  includesQuery(query, [
                    member.fullName,
                    [member.seniority, member.stream].filter(Boolean).join(' '),
                    member.legalLocation,
                  ]),
                ),
              },
        )
        .filter(({ members }) => members.length > 0)
    : projects;
